export const findStatus = (id: string, options: IOption[] = []) => {
  const find = options.find((e: IOption) => e.value === id);
  if (find) {
    return {
      id,
      label: find.label,
    };
  }
  return {
    id: "",
  };
};
